import i18next from 'i18next';

i18next.addResources('en', 'product', {
  HERO_TITLE: 'The Pivot',
  HERO_DESCRIPTION:
    'Less binge watching, more fat burning. The Pivot comes complete with everything you need to transform your workout at home—including premium equipment powered by the best of the fitness world’s coaches and classes. ',
  PAY_AS_LITTE: 'Or pay as little as {{price}}/mo.',
  MEMBERSHIP_FEE: '+ $ {{fee}}/mo. membership fee.',
  LEARN_MORE: 'Learn more',
  RESERVE: 'Reserve',
  DISCLAIMER: '$200 deposit to reserve for a Spring 2020 shipping date',
  white: 'Pure White',
  black: 'Matte Black',
  SPECS_TITLE: 'Specs\n& Details',
  SPECS_CONTENT:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt. ',
  HEIGHT: 'HEIGHT',
  WIDTH: 'WIDTH',
  DEPTH: 'DEPTH',
  WEIGHT: 'WEIGHT',
  INCLUDED: 'Everything included',
  SUBSCRIPTION_TITLE: 'Subscription',
  SUBSCRIPTION_CONTENT:
    'Vestibulum efficitur viverra sollicitudin. In hac habitasse platea dictumst. Fusce risus lectus, pretium ut dignissim quis, consequat feugiat turpis. Vestibulum efficitur viverra sollicitudin. In hac habitasse platea dictumst.',
  SUBSCRIPTION_LEARN_MORE: 'Learn more',
  REVIEW_TITLE: 'What people\nare saying',
  ITEM_1: '7.5 LB DUMBBELLS',
  ITEM_2: '25 LB BARBELL',
  ITEM_3: 'COLLARS',
  ITEM_4: '10 LB PLATES',
  ITEM_5: '5 LB PLATES',
  ITEM_6: '2.5 LB PLATES',
  ITEM_7: '1.25 LB PLATES',
  ITEM_8: 'HEART RATE MONITOR',
  ITEM_9: 'WORKOUT MAT',
  ITEM_10: 'FOAM ROLLER',
  FAQ: 'FAQ',
  QUESTION_1: 'When is the Pivot unit shipping?',
  QUESTION_2: 'How much does the Pivot unit cost?',
  QUESTION_3: 'How will I be contacted to purchase my unit?',
  QUESTION_4: 'How much space do I need?',
  QUESTION_5: 'How is the Pivot unit delivered and installed?',
  QUESTION_6: 'What is the warranty and refund policy?',
  ANSWER_1:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget.',
  ANSWER_2:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget.',
  ANSWER_3:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget.',
  ANSWER_4:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget.',
  ANSWER_5:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget.',
  ANSWER_6:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget.',
  RETURN_POLICY_TITLE: '30-day return policy',
  RETURN_POLICY_DESCRIPTION:
    'Lorem dolor sit amet, consectetur etiam adipiscing elit, sed ipsum do eiusmod tempor incididunt.',
  DELIVERY_TITLE: 'delivery / installation',
  DELIVERY_DESCRIPTION:
    'Lorem dolor sit amet, consectetur etiam adipiscing elit, sed ipsum do eiusmod tempor incididunt.',
  WARRANTY_TITLE: '1 year limited warranty',
  WARRANTY_DESCRIPTION:
    'Lorem dolor sit amet, consectetur etiam adipiscing elit, sed ipsum do eiusmod tempor incididunt.'
});
